import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChantiersInfrastructuresService {


  constructor(private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };

  getChantiersInfrastructures(url){
    return this.http.get(url+"/_api/web/lists/GetByTitle('ChantiersInfrastructures')/items",this.httpOptions); 
  }
  getPorts(url){
    return this.http.get(url+"/_api/web/lists/GetByTitle('ChantiersInfrastructures')/items",this.httpOptions); 
  }
  getChantiersInfrastructuresPagesById(url,Id){
    return this.http.get(url+"/_api/web/lists/GetByTitle('ChantiersInfrastructures')/items?"
    +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter= Id eq "+ Id +"",this.httpOptions);
  }
}
